import axios from "axios";
import {
  baseURL,
  distanceMatrixAPIEndpoint,
  distanceMatrixAPIKey,
  mapquestAPIEndpoint,
  mapquestAPIKey,
  geocodingAPIBaseURL,
  weatherAPIBaseURL,
  weatherAPIKey,
} from './config';
import { read } from "./storage";
import { logout, setToken } from "Redux/Auth/slice";
const token = read("access");
const client = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
});

client.interceptors.request.use(async (config) => {
  const access = read("access") || null;
  if (access) {
    config.headers.Authorization = `Bearer ${access}`;
  }
  return config;
});
client.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = read("refresh") || null;
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const store = require("Redux/store").default; // Use require inside the function
      if (
        !refreshToken ||
        refreshToken === "null" ||
        refreshToken === "undefined"
      ) {
        store.dispatch(logout());
      } else {
        try {
          const response = await client.post("token/refresh/", {
            refresh: refreshToken,
          });
          const newAccessToken = response.data.access;

          store.dispatch(
            setToken({
              access: newAccessToken,
            })
          );

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return client(originalRequest);
        } catch (refreshError) {
          store.dispatch(logout());
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

const distanceMatrix = axios.create({
  baseURL: distanceMatrixAPIEndpoint,
  headers: {
    "Content-Type": "application/json",
  },
  params: {
    key: distanceMatrixAPIKey,
    travelMode: 'driving',
    o: 'json',
  }
});

const mapquest = axios.create({
  baseURL: mapquestAPIEndpoint,
  headers: {
    'Content-Type': 'application/json',
  },
  params: {
    key: mapquestAPIKey,
    locale: 'en_US',
    unit: 'm',
    routeType: 'fastest',
    manMaps: false,
    doReverseGeocode: false,
  },
});

const geocoding = axios.create({
  baseURL: geocodingAPIBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
  params: {
    format: 'json',
    countrycodes: 'US',
    addressdetails: 1,
  }
});

const weather = axios.create({
  baseURL: weatherAPIBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
  params: {
    unitGroup: 'us',
    include: 'days',
    contentType: 'json',
    key: weatherAPIKey,
  }
});

export { client, distanceMatrix, mapquest, geocoding, weather };
